// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3en3M","imageUploader":"EGiftCard_imageUploader__2ruYQ"};